<template>
    <v-container fill-height fluid grid-list-xl class="pt-3">
        <v-layout wrap>
            <v-flex xs12>
                <v-card>
                    <v-layout column>
                        <v-card-actions class="mb-3">
                            <v-layout row>
                                <v-flex xs4>
                                    <v-card-text class="pl-2"
                                        >Search By Name</v-card-text
                                    >
                                    <vue-select2
                                        style="font-size: 27px"
                                        class="mb-3 ml-2 select2-custom"
                                        :options="accounts"
                                        label="displayName"
                                        v-model="account"
                                        :filterable="false"
                                        @search="onSearchAccounts"
                                        @input="onSelected"
                                    ></vue-select2>
                                </v-flex>
                                <v-flex xs6>
                                    <v-card-text class="pl-0"
                                        >Search By Phone Number</v-card-text
                                    >
                                    <v-layout row>
                                        <v-text-field
                                            solo
                                            label="Phone Number"
                                            v-model="phoneSearch"
                                            mask="###-###-####"
                                            @input="searchByPhone"
                                        ></v-text-field>
                                        <v-btn
                                            style="height: 48px;"
                                            class="ml-3"
                                            @click="searchDialog = true"
                                            >Search Accounts</v-btn
                                        >
                                        <v-btn
                                            style="height: 48px;"
                                            class="ml-3"
                                            color="info"
                                            @click="newAccountDialog = true"
                                            >New Account</v-btn
                                        >
                                        <v-btn
                                            v-if="account.nonUTA"
                                            style="height: 48px;"
                                            class="ml-3"
                                            color="info"
                                            @click="editAccount"
                                            >Edit Account</v-btn
                                        >
                                    </v-layout>
                                </v-flex>
                            </v-layout>
                        </v-card-actions>
                        <v-layout row justify-space-between>
                            <div v-if="account.accountID" class="mb-3">
                                <v-flex xs12 class="pt-0">
                                    <v-layout row>
                                        <v-layout column class="ml-4">
                                            <v-card-title
                                                primary-title
                                                class="pt-0 py-0"
                                            >
                                                <div>
                                                    <v-layout
                                                        row
                                                        v-if="account.nonUTA"
                                                        align-center
                                                        class="pl-2 py-2"
                                                    >
                                                        <h3
                                                            style="font-weight: 500 !important;"
                                                            class="headline my-0"
                                                        >
                                                            Account ID:
                                                            {{
                                                                account.accountID
                                                            }}
                                                        </h3>
                                                        <div
                                                            class="font-weight-medium ml-2 text-info"
                                                        >
                                                            Non UTA
                                                        </div>
                                                    </v-layout>
                                                    <h3
                                                        style="font-weight: 500 !important;"
                                                        class="headline my-0"
                                                        v-if="!account.nonUTA"
                                                    >
                                                        Account ID:
                                                        {{ account.accountID }}
                                                    </h3>
                                                </div>
                                            </v-card-title>
                                            <v-card-text class="mb-2 pt-0">
                                                <h4
                                                    class="card-title font-weight-regular"
                                                >
                                                    {{ account.name }}
                                                </h4>
                                                <p>
                                                    {{ account.hname }}
                                                </p>
                                                <p>
                                                    {{ account.address1 }}
                                                </p>
                                            </v-card-text>
                                            <div class="ml-4 pl-1 mt-0">
                                                <v-layout row class="mb-2">
                                                    <div
                                                        class="font-weight-medium mr-2"
                                                    >
                                                        Home:
                                                    </div>
                                                    <div>
                                                        {{ account.homePhone }}
                                                    </div>
                                                </v-layout>
                                                <v-layout row class="mb-2">
                                                    <div
                                                        class="font-weight-medium mr-2"
                                                    >
                                                        Cell:
                                                    </div>
                                                    <div>
                                                        {{ account.cellPhone }}
                                                    </div>
                                                </v-layout>
                                                <v-layout row class="mb-2">
                                                    <div
                                                        class="font-weight-medium mr-2"
                                                    >
                                                        Email:
                                                    </div>
                                                    <div>
                                                        {{
                                                            account.emailAddress
                                                        }}
                                                    </div>
                                                </v-layout>
                                            </div>
                                            <v-btn
                                                class="ml-3 mb-4 pb-4 mt-4"
                                                color="info"
                                                small
                                                @click="newStudentDialog = true"
                                            >
                                                New Student
                                            </v-btn>
                                        </v-layout>
                                        <!-- <v-layout row wrap align-end fluid>
                                        <v-card-actions
                                            class="mr-5"
                                            style="width: 100%;"
                                        >
                                            <v-text-field
                                                style="width: 50%;"
                                                class="mr-3"
                                                label="Note"
                                                v-model="note"
                                            ></v-text-field>
                                            <v-select
                                                :items="
                                                    countries.map(
                                                        (c) => c.value
                                                    )
                                                "
                                                ref="country"
                                                label="Country"
                                                v-model="country"
                                                :rules="countryRules"
                                                box
                                            >
                                            </v-select>
                                            <v-text-field
                                                ref="customCountry"
                                                class="ml-3"
                                                v-if="country == 'Other'"
                                                label="Country Name"
                                                v-model="customCountry"
                                                :rules="customCountryRules"
                                            ></v-text-field>
                                            <v-btn
                                                class="ml-3 mb-3"
                                                color="info"
                                                @click="newStudentDialog = true"
                                            >
                                                New Student
                                            </v-btn>
                                        </v-card-actions>
                                    </v-layout> -->
                                    </v-layout>
                                </v-flex>
                            </div>
                            <v-spacer></v-spacer>
                            <v-layout
                                align-end
                                class="mr-4 mb-3"
                                v-if="account.accountID"
                            >
                                <v-spacer></v-spacer>
                                <v-btn
                                    class="text-xs-right mr-3 mb-2"
                                    color="success"
                                    @click="submit"
                                    >Submit</v-btn
                                >
                            </v-layout>
                        </v-layout>
                    </v-layout>
                </v-card>
            </v-flex>
            <v-flex xs12>
                <student-list
                    v-if="students.length"
                    :students="students"
                    :classes="classes"
                    :account="account"
                    :gradesSetup="gradesSetup"
                    :dates="dates"
                    :charges="charges"
                    ref="studentsList"
                >
                </student-list>
            </v-flex>
        </v-layout>

        <v-dialog v-model="confirmDialog" max-width="500">
            <v-card>
                <v-card-title class="headline">Summary</v-card-title>

                <v-list two-line>
                    <template
                        v-for="(student, index) in students.filter(
                            (s) => s.duration != 'NONE'
                        )"
                    >
                        <v-list-tile avatar ripple>
                            <v-list-tile-content>
                                <v-list-tile-title>{{
                                    student.engName
                                }}</v-list-tile-title>
                                <v-list-tile-sub-title
                                    >{{ getDurationDisplay(student) }}
                                </v-list-tile-sub-title>
                            </v-list-tile-content>
                            <v-list-tile-action>
                                <v-list-tile-action-text
                                    class="font-weight-medium text-success headline"
                                    >{{
                                        student.total | currency
                                    }}</v-list-tile-action-text
                                >
                            </v-list-tile-action>
                        </v-list-tile>
                        <v-divider
                            v-if="
                                index + 1 <
                                    students.filter((s) => s.duration != 'NONE')
                                        .length
                            "
                        ></v-divider>
                    </template>
                </v-list>

                <v-card-actions class="text-xs-right pb-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        class="text-xs-right"
                        color="default"
                        dark
                        @click="confirmDialog = false"
                        >Close</v-btn
                    >
                    <!-- <v-btn
                        :disabled="processing"
                        class="text-xs-right"
                        color="success"
                        :loading="processing"
                        @click="confirm(true)"
                    >
                        Save
                    </v-btn> -->
                    <v-btn
                        :disabled="processing"
                        class="text-xs-right"
                        color="success"
                        :loading="processing"
                        @click="confirm(false)"
                    >
                        Save
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="searchDialog" max-width="1400">
            <v-card>
                <data-grid
                    class="accounts-search"
                    url="accounts"
                    :columns="accountsColumns"
                    :title="searchDialogTitle"
                    navigationPath="Account View"
                    navigationField="accountID"
                    v-bind:hideActions="true"
                    :onRowClicked="onSearchAccountsRowClicked"
                ></data-grid>
            </v-card>
        </v-dialog>
        <v-dialog persistent v-model="newAccountDialog" max-width="800">
            <new-account
                ref="newAccount"
                :closeNewAccountModal="closeNewAccountModal"
                :onCreated="onNewAccountCreated"
            ></new-account>
        </v-dialog>
        <v-dialog persistent v-model="newStudentDialog" max-width="400">
            <new-student
                :onCreated="onNewStudentCreated"
                :closeNewStudentModal="closeNewStudentModal"
                :account="account"
                :gradesSetup="gradesSetup"
            ></new-student>
        </v-dialog>
    </v-container>
</template>
<script>
import vueSelect2 from "vue-select";
import { getDomain, sum, groupBy } from "../../utils/helpers.js";
import odata from "odata-client";
import ky from "../../utils/ky.js";
import studentsList from "./components/StudentList.vue";
import payment from "./components/Payment.vue";
import newAccount from "./components/newAccount.vue";
import newStudent from "./components/newStudent.vue";
import { loadOptions } from "../../utils/smLookup.js";
import moment from "moment";

export default {
    components: {
        "vue-select2": vueSelect2,
        "student-list": studentsList,
        "new-account": newAccount,
        "new-student": newStudent,
    },
    data: () => ({
        phoneSearch: "",
        accounts: [],
        countries: [],

        account: {},
        country: "",
        customCountry: "",
        note: "",

        students: [],
        cardHistory: [],
        rates: [],
        dates: [],

        gradesSetup: [],
        classes: [],

        confirmDialog: false,
        processing: false,

        countryRules: [(value) => !!value || "Required."],

        customCountryRules: [(value) => !!value || "Required."],

        searchDialogTitle: "Accounts",
        searchDialog: false,

        newAccountDialog: false,
        newStudentDialog: false,

        regID: "",

        accountsColumns: [
            {
                sortable: true,
                label: "Name",
                field: "name",
                hidden: false,
                width: "200px",
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Name..",
                },
            },
            {
                sortable: false,
                label: "Account ID",
                field: "accountID",
                width: "115px",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Account ID..",
                },
            },
            {
                sortable: false,
                label: "Hebrew Name",
                width: "250px",
                field: "hname",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Hebrew Name..",
                },
            },
            {
                sortable: false,
                label: "Home Phone",
                field: "homePhone",
                width: "150px",
                hidden: false,
                searchValue: (value) => {
                    return value.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
                },
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Home Phone..",
                },
            },
            {
                sortable: false,
                label: "Cellphone",
                field: "cellPhone",
                width: "150px",
                hidden: false,
                searchValue: (value) => {
                    return value.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
                },
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Cellphone..",
                },
            },
            {
                sortable: false,
                label: "Address",
                field: "address1",
                width: "200px",
                hidden: false,
                filterOptions: {
                    enabled: true,
                    placeholder: "Search Address..",
                },
            },
            {
                sortable: false,
                label: "Email",
                field: "emailAddress",
                hidden: false,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "Father",
                field: "father",
                hidden: true,
                filterOptions: {
                    enabled: true,
                },
            },
            {
                sortable: false,
                label: "Shver",
                field: "shver",
                hidden: true,
                filterOptions: {
                    enabled: true,
                },
            },
        ],

        charges: [],
    }),
    async created() {
        await this.loadGradesSetup();
        this.loadRegID();

        await this.loadRates();
        await this.loadDates();
        await this.loadCharges();

        this.loadClasses();
        this.loadCountries();
    },
    methods: {
        async loadGradesSetup() {
            this.gradesSetup = await ky.get(
                this.$Progress,
                "api/lapidusDayCamp/getGradesSetup"
            );
        },
        loadRegID() {
            this.regID = "GC2020";
        },
        async loadClasses() {
            const classes = await ky.get(
                this.$Progress,
                "api/classSetup/get?regID=" + this.regID
            );

            this.classes = classes;
        },
        async loadRates() {
            const rates = await ky.get(
                this.$Progress,
                "api/lapidusDayCamp/getDayCampSetup"
            );

            this.rates = rates.filter((r) => r.udcregid == this.regID);
        },
        async loadDates() {
            const start = new Date(
                this.rates.filter(
                    (f) => f.udcclass == "G" && f.udcregid == this.regID
                )[0].udcstarts
            ).toISOString();
            const end = new Date(
                this.rates.filter(
                    (f) => f.udcclass == "G" && f.udcregid == this.regID
                )[0].udcends
            ).toISOString();

            const dates = await this.$http.get(
                `api/lapidusDayCamp/getHDates?startDate=${start}&endDate=${end}`
            );

            this.dates = this.setupDates(dates);
        },
        setupDates(dates) {
            return Object.keys(groupBy(dates, "hparsha")).map((week, index) => {
                const weekDays = groupBy(dates, "hparsha")[week];

                return {
                    parshe: week,
                    weekNumber: index,
                    dates: weekDays.map((d) => Date.parse(d.pardate)),
                    sunday: this.getDayOfWeek("Sunday", weekDays),
                    monday: this.getDayOfWeek("Monday", weekDays),
                    tuesday: this.getDayOfWeek("Tuesday", weekDays),
                    wednesday: this.getDayOfWeek("Wednesday", weekDays),
                    thursday: this.getDayOfWeek("Thursday", weekDays),
                    friday: this.getDayOfWeek("Friday", weekDays),
                    saturday: this.getDayOfWeek("Saturday", weekDays),
                };
            });
        },
        getDayOfWeek(day, weekDays) {
            return weekDays.find((w) => w.day == day);
        },
        async loadCardHistory() {
            this.cardHistory = await ky.get(
                this.$Progress,
                "api/lapidusDayCamp/getCardHistory?accountID=" +
                    this.account.accountID
            );
        },
        onSearchAccounts(search, loading) {
            loading(true);

            this.searchAccounts(loading, search);
        },
        async searchAccounts(loading, searchTerm) {
            const request = odata({
                service: getDomain() + "/odata/",
                resources: "accounts",
            }).top(30);

            request._headers[
                "Authorization"
            ] = this.$store.state.authentication.token;

            if (searchTerm) {
                request.filter(`startswith(lastname, '${searchTerm}')`);
            }

            const response = await request.get();

            this.accounts = JSON.parse(response.body).value.map((account) => {
                account.displayName =
                    account.lastName + " " + account.firstName;

                return account;
            });

            loading(false);
        },
        async loadCountries() {
            this.countries = await loadOptions("country");
        },
        onSearchAccountsRowClicked(account) {
            this.searchDialog = false;

            account.displayName = account.lastName + " " + account.firstName;

            this.account = account;

            this.onAccountSelected();
        },
        onNewAccountCreated(account) {
            account.displayName = account.lastName + " " + account.firstName;

            this.account = account;

            this.onAccountSelected();
        },
        onNewStudentCreated(student) {
            this.newStudentDialog = false;

            this.students.push(this.mapStudent(student));
        },
        async searchByPhone(value) {
            if (value.length < 10) return;

            const account = await this.$http.get(
                `api/lapidusDayCamp/getAccountByPhoneNumber?phoneNumber=${value}`
            );

            if (!account) {
                this.$notify({
                    text: "Account Does Not Exist",
                    group: "notification",
                    type: "warning",
                });

                return;
            }

            account.displayName = account.lastName + " " + account.firstName;

            this.account = account;

            this.onAccountSelected();
        },
        async onSelected(account) {
            if (!account) {
                return this.clearSelection();
            }

            this.accounts = [];

            this.onAccountSelected();
        },
        async onAccountSelected() {
            this.students = [];

            const exist = await this.validateExistence();

            if (exist) return;

            this.loadStudets();
            //this.loadCardHistory();
        },
        async validateExistence() {
            const exist = await this.$http.get(
                "api/girlsCamp/GetGirlsCampAccount?accountID=" +
                    this.account.accountID +
                    "&regID=" +
                    this.regID
            );

            if (!exist) return false;

            if (exist) {
                this.$notify({
                    text: "Account Already Exist",
                    group: "notification",
                    type: "error",
                });

                return true;
            }
        },
        async loadStudets() {
            const students = await ky.get(
                this.$Progress,
                `api/lapidusDayCamp/getStudents?linkId=${
                    this.account.accountLinkID
                }&pin=${this.account.pinNum}`
            );

            this.students = students
                .filter(this.hasDayCamp)
                .map(this.mapStudent);
        },
        hasDayCamp(student) {
            if (!this.gradesSetup.find((g) => g.grade == student.class)) return;

            return this.gradesSetup.find((g) => g.grade == student.class)
                .isGirlsCampAvail;
        },
        mapStudent(student) {
            student.duration = "NONE";
            student.selected = false;
            student.chosenClass = this.classes.find(
                (c) =>
                    c.grade == student.class && c.teacher.includes("Confirmed")
            )
                ? this.classes.find(
                      (c) =>
                          c.grade == student.class &&
                          c.teacher.includes("Confirmed")
                  )
                : "";
            student.editingAmount = false;
            student.paymentAmount = 0;
            student.lunchDoc = false;
            student.covidTest = false;
            student.insuranceCompany = "";
            student.insuranceID = "";

            student.charges = JSON.parse(
                JSON.stringify(
                    this.charges.map((charge) => {
                        charge.paymentAmount = charge.amount;

                        return charge;
                    })
                )
            );

            student.explicitWeeks = {
                week1: false,
                week2: false,
                week3: false,
                week4: false,
                week5: false,
                week6: false,
                week7: false,
                week8: false,
                week9: false,
            };

            student.price = () => this.getRate(student);
            student.total = 0;

            return student;
        },
        async loadCharges() {
            const charges = await this.$http.get("api/girlscamp/getcharges");

            this.charges = charges;
        },
        getRate(student) {
            const rateCode = this.getRateCode(student);

            if (!rateCode) return 0;

            const rate = this.rates.find((r) => r.udcclass == rateCode);

            switch (student.duration) {
                case "FULL":
                    return rate["udcamtf"];
                case "HALF 1":
                case "HALF 2":
                    return rate["udcamthalf"];
                case "CUSTOM":
                    const weekCount = Object.keys(student.explicitWeeks)
                        .map((key) => student.explicitWeeks[key])
                        .filter(Boolean).length;

                    return Math.min(
                        weekCount * rate["udcamt1w"],
                        rate["udcamtf"]
                    );
                default:
                    return 0;
            }
        },
        getRateCode(student) {
            return "G";
            // if (!this.country) return;

            // if (student.class == "B-06") {
            //     switch (this.country) {
            //         case "Satmar - Lapidus":
            //             return "LU-6";
            //         default:
            //             return "LO-6";
            //     }
            // }

            // if (!student.nonUTA) {
            //     switch (this.country) {
            //         case "Satmar - Lapidus":
            //             return "LU";
            //         default:
            //             if (
            //                 ["B-KNG", "B-NUR", "B-PRE1A"].includes(
            //                     student.class
            //                 )
            //             )
            //                 return "OU-YOUNG";

            //             return "OU-OLD";
            //     }
            // }

            // switch (this.country) {
            //     case "Satmar - Lapidus":
            //         return "LO";
            //     default:
            //         if (["B-KNG", "B-NUR", "B-PRE1A"].includes(student.class))
            //             return "OO-YOUNG";

            //         return "OO-OLD";
            // }
        },
        clearSelection() {
            this.phoneSearch = "";
            this.students = [];
        },
        getPaymentAmount() {
            return sum(
                this.students.map((s) => +s.paymentAmount || +s.price())
            );
        },
        submit() {
            if (
                !this.account ||
                this.students.every((s) => s.duration == "NONE")
            ) {
                this.$notify({
                    text: this.getErrorMessage(),
                    group: "notification",
                    type: "error",
                });

                return;
            }

            const validations = [
                //this.$refs.country.validate(true),
                this.$refs.studentsList.validate(true),
            ];

            // if (this.country == "Other") {
            //     validations.push(this.$refs.customCountry.validate(true));
            // }

            if (!validations.every(Boolean)) return;

            this.openConfirmDialog();
        },
        getErrorMessage() {
            if (!this.account) return "No Account Selected";

            return this.students.length
                ? "Please Chose Duration"
                : "No Students";
        },
        openConfirmDialog() {
            this.confirmDialog = true;
        },
        getDurationDisplay(student) {
            if (student.duration != "CUSTOM") return student.duration;

            const weekCount = Object.keys(student.explicitWeeks)
                .map((key) => student.explicitWeeks[key])
                .filter(Boolean).length;

            return weekCount + " Weeks";
        },
        getApplicationData() {
            const enrollments = this.students
                .filter((s) => s.duration != "NONE")
                .map((student) => ({
                    familyID: this.account.accountID,
                    studentID: student.studentID,
                    regID: this.regID,
                    regType: student.duration,
                    class: student.class,
                    classId: student.chosenClass.classID,
                    chargeCat: "GIRC",
                    chargeCode: this.regID,
                    amount: student.paymentAmount || student.price(),
                    week1: this.hasWeek(student, 1),
                    week2: this.hasWeek(student, 2),
                    week3: this.hasWeek(student, 3),
                    week4: this.hasWeek(student, 4),
                    week5: this.hasWeek(student, 5),
                    week6: this.hasWeek(student, 6),
                    week7: this.hasWeek(student, 7),
                    week8: this.hasWeek(student, 8),
                    week9: this.hasWeek(student, 9),
                    price: student.price(),
                    lunchDoc: student.lunchDoc,
                    covidTest: student.covidTest,
                    insuranceCompany: student.insuranceCompany,
                    insuranceID: student.insuranceID,
                }));

            const charges = this.students
                .filter((s) => s.duration != "NONE")
                .map((student) => {
                    return student.charges.map((charge) => {
                        return {
                            studentID: student.studentID,
                            chargeName: charge.name,
                            amount: charge.paymentAmount
                                ? charge.paymentAmount
                                : 0,
                        };
                    });
                });

            const data = {
                user: this.$store.state.authentication.user,
                // countryId:
                //     this.country != "Other"
                //         ? this.countries.find((c) => c.value == this.country).id
                //         : "",
                // countryDescription:
                //     this.country != "Other" ? this.country : this.customCountry,
                note: this.note,
                enrollments: enrollments,
                charges: charges.flat(),
            };

            return data;
        },

        hasWeek(student, week) {
            switch (student.duration) {
                case "FULL":
                    return true;
                case "CUSTOM":
                    const field = "week" + week;

                    return !!student.explicitWeeks[field];
                case "HALF 1":
                    return week >= 1 && week <= 5;
                case "HALF 2":
                    return week >= 5 && week <= 9;
            }
        },
        async confirm(goToNext = false) {
            const applicationData = this.getApplicationData();

            this.processing = true;

            try {
                await this.$http.post("api/girlsCamp/apply", applicationData);
            } catch (e) {
                this.processing = false;

                return;
            }

            this.processing = false;

            if (goToNext) {
                this.account = {};
                this.students = [];

                this.phoneSearch = "";
                this.country = "";
                this.customCountry = "";
                this.note = "";

                this.confirmDialog = false;

                this.$notify({
                    text: "Registration Successful",
                    group: "notification",
                    type: "success",
                });

                return;
            }

            this.$notify({
                text: "Registration Successful",
                group: "notification",
                type: "success",
            });

            this.confirmDialog = false;

            this.$router.push({
                name: "GirlsCampAccountView",
                params: { id: this.account.accountID },
            });
        },
        closeNewAccountModal() {
            this.newAccountDialog = false;
        },
        closeNewStudentModal() {
            this.newStudentDialog = false;
        },
        clearFilters() {
            this.columns.forEach((c) => {
                if (!c.filterOptions) return;

                c.filterOptions.filterValue;
            });
        },
        async editAccount() {
            const newAccountPrefill = await this.$http.get(
                "api/lapidusDayCamp/getNewAccount?accountID=" +
                    this.account.accountID
            );

            this.$refs.newAccount.prefill(newAccountPrefill);

            this.newAccountDialog = true;
        },
    },
};
</script>
<style>
.accounts-search.container {
    padding-top: 0px;
}
.v-btn__content {
    color: unset;
}
</style>
